import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { Upload, FileText, Eye, Download } from "lucide-react";
import { ConfirmDelete } from "./FieldsDialog";
import { DOC_CATS, label } from "./meta";

const fetchBlob = async (d) => (await api.get(`/supplier-documents/${d.id}/download`, { responseType: "blob" })).data;

export default function DocumentsSection({ supplierId }) {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("listino");
  const [busy, setBusy] = useState(false);
  const load = async () => { const { data } = await api.get(`/suppliers/${supplierId}/documents`); setItems(data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [supplierId]);

  const upload = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    try {
      for (const f of files) { const fd = new FormData(); fd.append("file", f); fd.append("category", cat); await api.post(`/suppliers/${supplierId}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }); }
      toast.success("Documento caricato"); load();
    } catch { toast.error("Caricamento non riuscito"); } finally { setBusy(false); }
  };
  const view = async (d) => {
    const w = window.open("", "_blank");
    try { const url = URL.createObjectURL(await fetchBlob(d)); if (w) w.location.href = url; else window.location.href = url; }
    catch { if (w) w.close(); toast.error("Impossibile aprire il documento"); }
  };
  const download = async (d) => {
    try { const url = URL.createObjectURL(await fetchBlob(d)); const a = document.createElement("a"); a.href = url; a.download = d.original_filename || "documento"; a.click(); setTimeout(() => URL.revokeObjectURL(url), 5000); }
    catch { toast.error("Download non riuscito"); }
  };
  const del = async (d) => { try { await api.delete(`/supplier-documents/${d.id}`); toast.success("Documento eliminato"); load(); } catch { toast.error("Eliminazione non riuscita"); } };

  return (
    <div className="card-soft p-4" data-testid="sec-documenti">
      <div className="flex flex-wrap gap-1.5 mb-3">
        {DOC_CATS.map(([v, l]) => <button key={v} data-testid={`doccat-${v}`} onClick={() => setCat(v)} className={`text-xs px-3 py-1.5 rounded-full border ${cat === v ? "bg-brand text-white border-brand" : "bg-white text-muted-foreground"}`}>{l}</button>)}
      </div>
      <label data-testid="doc-upload" className="block cursor-pointer mb-4">
        <div className="flex items-center justify-center gap-2 bg-ink text-white rounded-lg py-2.5 text-sm font-medium hover:opacity-90 transition-opacity"><Upload size={17} /> Carica PDF o documento</div>
        <input type="file" accept="application/pdf,image/*,.doc,.docx,.xls,.xlsx" multiple className="hidden" onChange={(e) => { upload(Array.from(e.target.files)); e.target.value = ""; }} />
      </label>
      {busy && <p className="text-xs text-muted-foreground animate-pulse mb-2">Caricamento in corso…</p>}
      {items.length === 0 ? <p className="text-sm text-muted-foreground">Nessun documento.</p> : (
        <div className="space-y-2">
          {items.map((d) => (
            <div key={d.id} data-testid={`doc-${d.id}`} className="flex items-center gap-3 p-3 rounded-lg bg-slate-50">
              <FileText size={20} className="text-brand shrink-0" />
              <div className="min-w-0 flex-1"><p className="text-sm font-medium truncate">{d.original_filename}</p><p className="text-xs text-muted-foreground">{label(DOC_CATS, d.category)} · {new Date(d.created_at).toLocaleDateString("it-IT")}</p></div>
              <Button size="icon" variant="outline" data-testid={`doc-view-${d.id}`} onClick={() => view(d)}><Eye size={15} /></Button>
              <Button size="icon" variant="outline" data-testid={`doc-download-${d.id}`} onClick={() => download(d)}><Download size={15} /></Button>
              <ConfirmDelete small testid={`doc-del-${d.id}`} onConfirm={() => del(d)} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
